<template>
  <page title="Equipment Setup">
    <tab-switcher id="es" :tabs="tabs" />
  </page>
</template>

<script>
import { updateQueryParam } from "@/lib/url.js";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import ComponentTypes from "@/ComponentTypes/ComponentTypes.vue";
import EquipmentTypes from "@/EquipmentTypes/EquipmentTypes.vue";

export default {
  components: { Page, TabSwitcher },
  data() {
    return {
      tabs: [
        {
          id: "equipmentTypes",
          name: "Equipment Types",
          ref: "equipmentTypesTab",
          component: EquipmentTypes,
          beforeTabChange: (ref) => {
            updateQueryParam("component_type_ids", null);
            ref?.refreshComponentIds();
            return true;
          }
        },
        {
          id: "componentTypes",
          name: "Component Types",
          component: ComponentTypes
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
:deep(> *.card-body) {
  min-height: 350px;
}
</style>
